import { render, staticRenderFns } from "./FinalizarCarrinho.vue?vue&type=template&id=00c1a40e&scoped=true"
import script from "./FinalizarCarrinho.vue?vue&type=script&lang=js"
export * from "./FinalizarCarrinho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1a40e",
  null
  
)

export default component.exports